import {Params} from '@feathersjs/feathers'

import config from '../../config'

import {ProviderId, ProviderProfileImage} from '../../types'

import * as feathersService from '../feathers'
import httpJsonAuth from '../http-json-auth'

export const RESOURCE = 'providerProfileImage'

const get = async (params?: Params) => feathersService.find<ProviderProfileImage>(RESOURCE, params)

export const getByProvider = async (provider: ProviderId) => {
  const parameters = {
    query: {
      provider,
    },
  }
  return get(parameters)
}

export const upload = async (payload: {file: File[]; provider: ProviderId}) => {
  const response = await httpJsonAuth.upload({
    method: 'POST',
    url: `${config.services.api.baseUrl}/${RESOURCE}`,
    body: payload,
  })
  return response.json
}

export const remove = async (id: string) =>
  feathersService.remove<ProviderProfileImage>(RESOURCE, id)

export const removeMultiple = async (ids: string[]) => Promise.all(ids.map(id => remove(id)))
